import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { EnvironmentName } from '@blaze-shared/api-contracts-domain';
import { SharedModule } from '@blaze-shared/shared-feature';
import { DialogComponent } from '@blaze-shared/shared-ui';

export interface CopyDataDialogInput {
  currentEnvironment: EnvironmentName | undefined;
  sourceEnvironment: EnvironmentName | undefined;
}

@Component({
  selector: 'blaze-table-copy-data-dialog',
  templateUrl: './blaze-table-copy-data-dialog.component.html',
  styleUrls: ['./blaze-table-copy-data-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogComponent, MatIconModule, SharedModule],
})
export class BlazeTableCopyDataDialogComponent {
  private readonly dialogData = inject(MAT_DIALOG_DATA);
  private readonly dialogRef =
    inject<MatDialogRef<BlazeTableCopyDataDialogComponent, boolean>>(MatDialogRef);

  protected currentEnvironment = signal<EnvironmentName>('Development');
  protected sourceEnvironment = signal<EnvironmentName>('Production');
  protected sourceEnvironmentAbbrv = signal<'DEV' | 'PROD'>('PROD');

  constructor() {
    this.currentEnvironment.set(this.dialogData.currentEnvironment);
    this.sourceEnvironment.set(this.dialogData.sourceEnvironment);

    if (this.sourceEnvironment() === 'Production') {
      this.sourceEnvironmentAbbrv.set('PROD');
    } else if (this.sourceEnvironment() === 'Development') {
      this.sourceEnvironmentAbbrv.set('DEV');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
